var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #FF4045;\n        stroke-miterlimit: 10;\n        stroke-width: 2.33px;\n      }\n\n      .cls-2 {\n        fill: #FF4045;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m35.6,13.61c-3.91,3.45-7.6,6.75-11.13,10.59,3.53,3.84,7.21,7.14,11.13,10.51-1.53.84-7.9-3.84-13.04-8.36-2.15,2.53-4.3,5.29-6.37,8.52-2.61-2-1.92-4.22-.69-5.91.69-.92,2.46-2.76,4.68-4.76-2.23-2.07-3.99-3.84-4.68-4.76-1.23-1.76-1.92-3.91.69-5.91,2.07,3.22,4.22,5.99,6.37,8.52,5.14-4.53,11.51-9.21,13.04-8.44Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 24.19,
    r: 17.01
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleCross);
export default __webpack_public_path__ + "static/media/icon-circle-cross.0a548b6a869a2a01fb06301bd408e094.svg";
export { ForwardRef as ReactComponent };